export { default } from "../components/we-moved";
